import React, { FC } from 'react';

import InlineSearchSelectWrapper from './components/StyledSelect/InlineSearchSelectWrapper';
import StyledSelectContainer from './components/StyledSelectContainer';

export interface StyledReactSelectProps {
  defaultValue?: unknown;
  canSelectAll?: boolean;
  isTargetDisabled?: boolean;
  inlineSearch?: boolean;
  isSearchable?: boolean;
  showArrow?: boolean;
  target?: unknown;
  className?: string;
  value?: unknown;
  label?: unknown;
  options?: unknown[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getOptionLabel?: (option: any) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (option?: any, triggeredAction?: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getOptionValue?: (option: any) => any;
  /**
   * Whether an option counts as already chosen. react-select answers this from
   * the props of the render *before* the one being built, so read the selection
   * from the second argument rather than from anything the caller closes over.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isOptionSelected?: (option: any, selectValue: any) => boolean;
  isDisabled?: boolean;
  placeholder?: string;
  error?: boolean | string;
  /** Sizes the control — `StyledSelect` maps it through `heightBySize`. */
  size?: 'small' | 'medium' | 'large' | 'none';
  /** Lands on the underlying input, so a caller can address it by id. */
  inputId?: string;
  /**
   * Whether Tab commits the focused option. react-select defaults it to `true`,
   * which makes tabbing out of an opened menu a selection.
   */
  tabSelectsValue?: boolean;
  autoWidth?: boolean;
  styles?: unknown;
  required?: boolean;
  isMulti?: boolean;
  onBlur?: () => void;
  filterOption?: (option: { label: string; value: number | string }, string: string) => void;
  onFocus?: () => void;
  isLoading?: boolean;
  isClearable?: boolean;
  /**
   * Whether a chosen option leaves the menu. react-select drops it for a multi
   * by default, so the list shortens as you pick and the same row cannot unpick.
   */
  hideSelectedOptions?: boolean;
  noOptionsMessage?: () => React.ReactNode;
  onInputChange?: (searchTerm: string, action: { action: string }) => void;
  inputValue?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formatGroupLabel?: (data: any) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isOptionDisabled?: (option: any) => boolean;
  components?: Record<string, React.ComponentType<unknown>>;
  'aria-label'?: string;
  /**
   * Id of an element outside this component that describes the control — an
   * error or hint the consumer renders itself. The `error` message this
   * component renders is linked on its own; the two are combined.
   */
  'aria-describedby'?: string;
  /**
   * Id of the element that names the control. Set this or `aria-label` when the
   * name differs from the rendered `label`, which names the control on its own.
   */
  'aria-labelledby'?: string;
}

const StyledReactSelect: FC<StyledReactSelectProps> = ({
  canSelectAll,
  isTargetDisabled,
  showArrow,
  target,
  inlineSearch,
  ...props
}) => {
  if (inlineSearch) {
    return (
      // @ts-expect-error this will resolve once more of these pieces are converted
      <InlineSearchSelectWrapper
        inlineSearch
        isTargetDisabled={isTargetDisabled}
        showArrow={showArrow}
        target={target}
        {...props}
      />
    );
  }
  return (
    // @ts-expect-error this will resolve once more of these pieces are converted
    <StyledSelectContainer canSelectAll={canSelectAll} {...props} />
  );
};

export default StyledReactSelect;
